/**
 * Configuration section layout. Labor clock-in runs on build-line and inventory-alternate work routes;
 * the queue route is list-only.
 */

import { Outlet } from "react-router-dom";

export function ConfigurationLayout() {
  return <Outlet />;
}
